import { Routes } from '@angular/router';
import { adminGuard } from './core/guards/admin.guard';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/startup/startup.component').then((m) => m.StartupComponent),
  },
  {
    path: 'startup',
    pathMatch: 'full',
    redirectTo: '',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'signup',
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'choose' },
      { path: 'choose', loadComponent: () => import('./pages/auth/signup/signup-choice.component').then((m) => m.SignupChoiceComponent) },
      { path: 'code', loadComponent: () => import('./pages/auth/signup/signup-code.component').then((m) => m.SignupCodeComponent) },
      { path: 'tenant', loadComponent: () => import('./pages/auth/signup/signup-tenant.component').then((m) => m.SignupTenantComponent) },
      { path: 'form', loadComponent: () => import('./pages/auth/signup/signup.component').then((m) => m.SignupComponent) },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./shared/layouts/base-layout/base-layout.component').then((m) => m.BaseLayoutComponent),
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent) },
      { path: 'crm/intake', loadComponent: () => import('./pages/crm/intake/intake.component').then((m) => m.IntakeComponent) },
      // Contacts routes (canonical)
      { path: 'crm/contacts', loadComponent: () => import('./pages/crm/clients-list/clients-list.component').then((m) => m.ClientsListComponent) },
      { path: 'crm/contacts/new', loadComponent: () => import('./pages/crm/create-client/create-client.component').then((m) => m.CreateClientComponent) },
      { path: 'crm/contacts/:id', loadComponent: () => import('./pages/crm/client-detail/client-detail.component').then((m) => m.ClientDetailComponent) },
      // Legacy /crm/clients/* routes kept for backward compatibility
      { path: 'crm/clients', loadComponent: () => import('./pages/crm/clients-list/clients-list.component').then((m) => m.ClientsListComponent) },
      { path: 'crm/clients/new', loadComponent: () => import('./pages/crm/create-client/create-client.component').then((m) => m.CreateClientComponent) },
      { path: 'crm/clients/:id', loadComponent: () => import('./pages/crm/client-detail/client-detail.component').then((m) => m.ClientDetailComponent) },
      { path: 'crm/conflicts', loadComponent: () => import('./pages/crm/conflicts/conflicts.component').then((m) => m.ConflictsComponent) },
      { path: 'crm/matters', loadComponent: () => import('./pages/crm/matters-list/matters-list.component').then((m) => m.MattersListComponent) },
      { path: 'crm/matters/new', loadComponent: () => import('./pages/crm/create-matter/create-matter.component').then((m) => m.CreateMatterComponent) },
      { path: 'crm/matters/:id', loadComponent: () => import('./pages/crm/matter-detail/matter-detail.component').then((m) => m.MatterDetailComponent) },
      { path: 'crm/tasks', loadComponent: () => import('./pages/tasks/tasks-list/tasks-list.component').then((m) => m.TasksListComponent) },
      { path: 'calendar', loadComponent: () => import('./pages/calendar/calendar-page.component').then((m) => m.CalendarPageComponent) },
      { path: 'docket', redirectTo: 'calendar', pathMatch: 'full' },
      { path: 'billing', redirectTo: 'billing/invoices', pathMatch: 'full' },
      { path: 'billing/invoices', loadComponent: () => import('./pages/billing/invoices/invoices.component').then((m) => m.InvoicesComponent) },
      { path: 'billing/invoices/new', loadComponent: () => import('./pages/billing/create-invoice/create-invoice.component').then((m) => m.CreateInvoiceComponent) },
      { path: 'billing/invoices/:id', loadComponent: () => import('./pages/billing/invoice-detail/invoice-detail.component').then((m) => m.InvoiceDetailComponent) },
      { path: 'billing/time', loadComponent: () => import('./pages/billing/time-tracking/time-tracking.component').then((m) => m.TimeTrackingComponent) },
      { path: 'billing/expenses', loadComponent: () => import('./pages/billing/expenses/expenses-menu.component').then((m) => m.ExpensesMenuComponent) },
      { path: 'reports', loadComponent: () => import('./pages/billing/reports/reports.component').then((m) => m.BillingReportsComponent) },
      { path: 'documents/:id', loadComponent: () => import('./pages/documents/document-viewer.component').then((m) => m.DocumentViewerComponent) },
      { path: 'assistant', loadComponent: () => import('./assistant/components/chat/assistant-chat.component').then((m) => m.AssistantChatComponent) },
      { path: 'profile', loadComponent: () => import('./pages/profile/profile.component').then((m) => m.ProfileComponent) },
      { path: 'admin', canActivate: [adminGuard], loadComponent: () => import('./pages/admin/admin.component').then((m) => m.AdminComponent) },
      { path: 'admin/ai-telemetry', canActivate: [adminGuard], loadComponent: () => import('./pages/admin/ai-telemetry/ai-telemetry.component').then((m) => m.AiTelemetryComponent) },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
